import type { HeaderNavInterface } from "src/lib/utils/interfaces";

type Sub = NonNullable<HeaderNavInterface["submenu"]>[number];

const SCROLL = "scroll" as const;

function defaultServiceSubmenu(sectionId: string): Sub[] {
  return [
    { label: "Bảo dưỡng - bảo trì", target: sectionId, action: SCROLL },
    { label: "Vệ sinh máy lạnh", target: sectionId, action: SCROLL },
    { label: "Lắp đặt máy lạnh", target: sectionId, action: SCROLL },
  ];
}

function defaultProductSubmenu(sectionId: string): Sub[] {
  return [
    { label: "Máy lạnh nhà xưởng", target: sectionId, action: SCROLL },
    { label: "Máy lạnh một hướng thổi LG", target: sectionId, action: SCROLL },
    { label: "Máy lạnh văn phòng", target: sectionId, action: SCROLL },
    { label: "Máy lạnh trung tâm (VRV)", target: sectionId, action: SCROLL },
    { label: "Máy lạnh âm trần", target: sectionId, action: SCROLL },
  ];
}

export function sectionIdFromTarget(item: HeaderNavInterface): string | undefined {
  const t = item.target?.replace(/^#/, "").trim();
  return t || undefined;
}

/** Bỏ dấu + lower: so khớp ổn định với mọi NFC/NFD từ CMS. */
function foldLabel(s: string | undefined): string {
  return (s ?? "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function targetSlug(item: HeaderNavInterface): string {
  return (item.target ?? "").replace(/^#/, "").trim().toLowerCase();
}

/** CMS: scroll/link + không submenu — vẫn có menu xổ theo label hoặc target. */
function legacyMegaSubmenu(item: HeaderNavInterface): Sub[] | undefined {
  const label = foldLabel(item.label);
  const slug = targetSlug(item);

  const isProducts =
    label.includes("san pham") ||
    slug === "section-products" ||
    slug.includes("san-pham") ||
    slug.includes("product");
  const isServices =
    label.includes("dich vu") ||
    slug === "section-services" ||
    slug.includes("dich-vu") ||
    slug.includes("service");

  if (!isProducts && !isServices) return undefined;

  const sidProducts = sectionIdFromTarget(item) || "section-products";
  const sidServices = sectionIdFromTarget(item) || "section-services";

  if (isProducts) return defaultProductSubmenu(sidProducts);
  return defaultServiceSubmenu(sidServices);
}

/** Dropdown: `submenu`, `popover` không con, hoặc mega legacy (Sản phẩm / Dịch vụ). */
export function effectiveNovaPressSubmenu(item: HeaderNavInterface): Sub[] {
  if (item.submenu?.length) return item.submenu;
  if (item.action === "popover" && item.target) {
    const sid = sectionIdFromTarget(item);
    if (sid) return [{ label: "Xem chi tiết", target: sid, action: SCROLL }];
  }
  return legacyMegaSubmenu(item) ?? [];
}

export function novaPressNavHasDropdown(item: HeaderNavInterface): boolean {
  return effectiveNovaPressSubmenu(item).length > 0;
}
